// Default error
export const DEFAULT_ERROR = 'Notifications/Renter/DefaultError';

// Payment method saved
export const PAYMENT_SAVED_SUCCESS = 'Notifications/Renter/PaymentSavedSuccess';
export const PAYMENT_UPDATED_SUCCESS = 'Notifications/Renter/PaymentUpdatedSuccess';

// Payment paid
export const PAYMENT_PAID = 'Notifications/Renter/PaymentPaid';
export const PAYMENT_PAID_OFFLINE = 'Notifications/Renter/PaymentPaidOffline';

// Payment method unprocessable
export const PAYMENT_METHOD_UNPROCESSABLE = 'Notifications/Renter/PaymentMethodUnprocessable';
export const PAYMENT_METHOD_INSUFFICIENT_FUNDS = 'Notifications/Renter/PaymentMethodInsufficientFunds';
export const PLAID_CREATE_PAYMENT_METHOD_ERROR = 'Notifications/Renter/PlaidCreatePaymentMethodError';

// Payment scheduled
export const PAYMENT_SCHEDULED_SUCCESS = 'Notifications/Renter/PaymentScheduledSuccess';
export const PAYMENT_SCHEDULED_MAYBE_LATE = 'Notifications/Renter/PaymentScheduledMaybeLate';
export const PAYMENT_SCHEDULED_ALWAYS_LATE = 'Notifications/Renter/PaymentScheduledAlwaysLate';

// Payment unprocessable, for example card declined
export const PAYMENT_UNPROCESSABLE = 'Notifications/Renter/PaymentUnprocessable';

// Payment cancelled
export const PAYMENT_CANCEL_SUCCESS = 'Notifications/Renter/PaymentCancelSuccess';

// MicroDeposits
export const MICRODEPOSIT_SUCCESS = 'Notifications/Renter/MicroDepositSuccess';
export const MICRODEPOSIT_FAIL = 'Notifications/Renter/MicroDepositFail';
export const MICRODEPOSIT_LIMIT_REACHED = 'Notifications/Renter/MicroDepositLimit';

// Rent amount change
export const REVIEW_RENT_AMOUNT_CHANGE = 'Notifications/Renter/ReviewRentAmountChange';
export const RENT_AMOUNT_CHANGE_ACCEPTED = 'Notifications/Renter/RentAmountChangeAccepted';
export const RENT_AMOUNT_CHANGE_REMINDER = 'Notifications/Renter/RentAmountChangeReminder';
export const RENT_AMOUNT_CHANGE_EXPIRED = 'Notifications/Renter/RentAmountChangeExpired';

// One Time Payment
export const ONE_TIME_PAYMENT_PAID = 'Notifications/Renter/OneTimePaymentPaid';

// Payment Plan Installment Payment
export const PAYMENT_PLAN_INSTALLMENT_PAID = 'Notifications/Renter/PaymentPlanInstallmentPaid';

// Api timeout message
export const PAYMENT_TIMEOUT = 'Notifications/Renter/PaymentTimeout';

// Move-in Costs
export const MOVE_IN_COSTS_SCHEDULED = 'Notifications/Renter/MoveInCostsPaymentScheduled';
export const MOVE_IN_COSTS_PAID = 'Notifications/Renter/MoveInCostsPaymentPaid';

// Past Due Warning When Payment Plan Requested
export const PAST_DUE_WARNING_IF_PAYMENT_PLAN_AVAILABLE = 'Notifications/Renter/PaymentPlanPastDueWarning';

// Payment Reporting Opt In
export const PAYMENT_REPORTING_OPT_IN_SUCCESS = 'Notifications/Renter/PaymentReportingOptInSuccess';
export const PAYMENT_REPORTING_OPT_OUT_SUCCESS = 'Notifications/Renter/PaymentReportingOptOutSuccess';

// Multiple Payment Methods
export const PAYMENT_METHOD_DELETED_SUCCESS = 'Notifications/Renter/PaymentMethodDeletedSuccess';
export const PAYMENT_SCHEDULED_SUCCESS_DETAILED = 'Notifications/Renter/PaymentScheduledSuccessDetailed';
export const NEW_PAYMENT_METHOD_ADDED_SUCCESS = 'Notifications/Renter/NewPaymentMethodAddedSuccess';
export const PAYMENT_METHOD_UPDATED_SUCCESS = 'Notifications/Renter/PaymentMethodUpdatedSuccess';

// Bank Account Verification
export const VERIFY_SINGLE_BANK_ACCOUNT_BANNER = 'Notifications/Renter/VerifySingleBankAccountBanner';
export const VERIFY_MULTIPLE_BANK_ACCOUNTS_BANNER = 'Notifications/Renter/VerifyMultipleBankAccountsBanner';

// Credit Tracking
export const CREDIT_TRACKING_ENROLL_SUCCESS = 'Notifications/Renter/CreditTrackingEnrollSuccess';
export const CREDIT_TRACKING_ENROLL_FAILURE = 'Notifications/Renter/CreditTrackingEnrollFailure';
export const CREDIT_TRACKING_UNENROLL_SUCCESS = 'Notifications/Renter/CreditTrackingUnenrollSuccess';
export const CREDIT_TRACKING_UNENROLL_FAILURE = 'Notifications/Renter/CreditTrackingUnenrollFailure';
